import { create } from "zustand";

interface SidebarStore {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
  isSettingsPanelOpen: boolean;
  setSettingsPanelOpen: (open: boolean) => void;
  toggleSettingsPanel: () => void;
  isLeaguePanelOpen: boolean;
  setLeaguePanelOpen: (open: boolean) => void;
  toggleLeaguePanel: () => void;
}

const useSidebarStore = create<SidebarStore>((set) => ({
  isCollapsed: window.innerWidth < 1440,
  setIsCollapsed: (collapsed) => set({ isCollapsed: collapsed }),
  toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),

  isSettingsPanelOpen: false,
  setSettingsPanelOpen: (open) =>
    set(open ? { isSettingsPanelOpen: true, isLeaguePanelOpen: false } : { isSettingsPanelOpen: false }),
  toggleSettingsPanel: () =>
    set((state) =>
      state.isSettingsPanelOpen
        ? { isSettingsPanelOpen: false }
        : { isSettingsPanelOpen: true, isLeaguePanelOpen: false }
    ),

  isLeaguePanelOpen: false,
  setLeaguePanelOpen: (open) =>
    set(open ? { isLeaguePanelOpen: true, isSettingsPanelOpen: false } : { isLeaguePanelOpen: false }),
  toggleLeaguePanel: () =>
    set((state) =>
      state.isLeaguePanelOpen
        ? { isLeaguePanelOpen: false }
        : { isLeaguePanelOpen: true, isSettingsPanelOpen: false }
    ),
}));

export default useSidebarStore;
